import { useState } from "react";
import styles from "./embedVideo.module.scss";

function EmbedVideo(props: any) {
  const { videoSrc, className = "", allowAutoplay = true } = props;
  const { showThumbNail = true } = props;
  const [showYoutubeThumbnail, setShowYoutubeThumbnail] = useState(showThumbNail);

  function playVideo() {
    setShowYoutubeThumbnail((_isVisible: any) => !_isVisible);
  }
  const updatedVideoSrc = !allowAutoplay && videoSrc
    ? (() => {
      try {
        const url = new URL(videoSrc);
        url.searchParams.delete("autoplay");
        return url.toString();
      } catch {
        return videoSrc;
      }
    })()
    : videoSrc;

  let renderContent = <span />;
  if (showYoutubeThumbnail) {
    renderContent = (
      <div className={styles.youtube_thumbnail_container}>
        <div className={styles.youtube_thumbnail_mask}>
          <img
            alt="videoIcon"
            src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/common/videoplay.png`}
            onClick={playVideo}
          />
        </div>
      </div>
    );
  } else {
    renderContent = (
      <iframe
        src={updatedVideoSrc}
        allowFullScreen
        title="videoFrame"
        {...(allowAutoplay ? { allow: "autoplay" } : {})}
        data-clarity-mask="True"
      />
    );
  }

  return (
    <div className={`text-center search-video d-flex ${styles.video_container} ${className}`}>
      {renderContent}
    </div>
  );
}

export default EmbedVideo;
